module.exports = __webpack_public_path__ + "img/551e6f5.jpg";